import reduce from './reduce';
export default (function (obj, keys) {
  return reduce(obj, function (r, curr, key) {
    if (!keys.includes(key)) {
      r[key] = curr;
    }
    return r;
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/omit.js
// module id = 109
// module chunks = 0